// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const fr = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Accueil',
    search: 'Rechercher',
    login: 'Connexion',
    register: 'S\'inscrire',
    dashboard: 'Tableau de bord',
    reservas: 'Réservations',
    equipo: 'Équipe',
    logout: 'Déconnexion',
    legal: 'Mentions légales',
    legalNotice: 'Mentions légales',
    privacy: 'Politique de confidentialité',
    cookies: 'Politique de cookies',
    terms: 'Conditions générales',
    clientes: 'Clients',
  },
  legal: {
    noticeTitle: 'Mentions légales',
    noticeBody:
      'Conformément à la loi espagnole 34/2002 (LSSI-CE), ce site web est la propriété de bitutravel. E-mail de contact : legal@bitutravel.app. L\'utilisation du site vous confère la qualité d\'utilisateur et implique l\'acceptation des présentes conditions.',
    privacyTitle: 'Politique de confidentialité',
    privacyBody:
      'Nous traitons vos données uniquement pour gérer votre compte, vos réservations et la facturation exigée par la réglementation espagnole (RGPD et LOPDGDD). Nous ne cédons jamais vos données à des tiers à des fins commerciales. Vous pouvez exercer vos droits d\'accès, de rectification, de suppression et de portabilité en écrivant à privacy@bitutravel.app.',
    cookiesTitle: 'Politique de cookies',
    cookiesBody:
      'bitutravel utilise uniquement des cookies techniques strictement nécessaires : la session d\'authentification et votre préférence de langue. Nous n\'utilisons aucun cookie publicitaire ni de suivi de tiers.',
    termsTitle: 'Conditions générales',
    termsBody:
      'Les réservations sont demandées via la plateforme et restent soumises à l\'approbation du propriétaire et à la politique d\'annulation choisie. La facturation des entreprises est émise conformément à la réglementation espagnole (TVA et IRPF applicables). bitutravel agit en tant qu\'intermédiaire entre l\'entreprise demanderesse et le propriétaire du logement. Les prix affichés n\'incluent pas la TVA (21%), qui est ajoutée au total de la réservation.',
  },
  landing: {
    heroTitle: 'L\'hébergement d\'entreprise, en toute simplicité',
    heroSubtitle:
      'Trouvez des hébergements de qualité de moyenne durée pour vos équipes partout en Espagne. La confiance des plus grandes entreprises.',
    checkIn: 'Arrivée',
    checkOut: 'Départ',
    guests: 'Voyageurs',
    search: 'Rechercher',
    featured: 'Séjours en vedette',
    featuredIn: 'En vedette à {{city}}',
    guestsValue: '{{count}} voyageurs',
    where: 'Où',
    when: 'Quand',
    who: 'Qui',
    searchDestinations: 'Rechercher des destinations',
    addDates: 'Ajouter des dates',
    addGuests: 'Ajouter des voyageurs',
    howItWorks: 'Comment ça marche',
    step1Title: 'Cherchez',
    step1Desc: 'Explorez des hébergements vérifiés dans les principales villes d\'Espagne.',
    step2Title: 'Réservez',
    step2Desc: 'Réservez des séjours de moyenne durée pour vos équipes aux conditions corporate.',
    step3Title: 'Installez-vous',
    step3Desc: 'Votre équipe s\'installe. Nous gérons la facture et la note de frais du voyageur.',
    perNight: '/ nuit',
    perNightPlusIva: '/ nuit + TVA',
    comingSoon: 'Bientôt disponible',
    trustedBy: 'Ils nous font déjà confiance',
    testimonialsTitle: 'Ce que disent nos clients',
    review1Text: 'Depuis que j\'utilise bitutravel, les factures arrivent automatiquement et tout le processus est simplifié.',
    review1Author: 'María López',
    review1Role: 'Responsable mobilité, cabinet de conseil tech',
    review2Text: 'Nous gérons l\'hébergement de toute l\'équipe sur une seule plateforme. Les gains de temps et de coût sont évidents.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Directeur des opérations, société d\'ingénierie',
    review3Text: 'La facturation entreprise et la note de frais voyageur arrivent prêtes pour l\'audit. Zéro travail administratif.',
    review3Author: 'Elena García',
    review3Role: 'Responsable finance, multinationale',
    illustrativeImage: 'image illustrative',
  },
  search: {
    allSpain: 'Toute l\'Espagne',
    allDistricts: 'Tous les quartiers',
    viewAllResults: 'Voir tous les résultats',
    results: 'résultats',
    sort: 'Trier',
    sortPriceAsc: 'Prix : croissant',
    sortPriceDesc: 'Prix : décroissant',
    noResults: 'Aucun hébergement dans cette zone.',
    noResultsForFilters:
      'Aucun hébergement ne correspond à ces filtres. Essayez de retirer les dates ou de modifier les filtres.',
    clearFilters: 'Effacer les filtres',
    areaPlaceholder: 'Quartier, zone ou code postal',
    showMap: 'Carte',
    showMore: 'Voir plus',
    backToTop: 'Revenir en haut',
    typeAll: 'Tout',
    placeEntire: 'Appartement entier',
    placeRoom: 'Chambre privée',
    placeHotel: 'Hôtel',
    dates: 'Dates',
    sortRecommended: 'Recommandé',
    size: 'Chambres',
    sizeAny: 'Toutes',
    sizeSingle: '1 chambre',
    sizeDouble: '2 chambres',
    size3plus: '3+ chambres',
    rooms: 'Chambres',
    units: 'Unités',
    grouping: 'Grouper',
    groupAny: 'Indifférent',
    typeInCity: '{{type}} à {{city}}',
    forNights: 'pour {{count}} nuits',
    filters: 'Filtres',
    groupSameBuilding: 'Même bâtiment',
    groupSameArea: 'Zone la plus proche',
    groupSameCategory: 'Même catégorie',
    roomsValue: '{{count}} ch.',
    unitsValue: '{{count}} u.',
    groupResults: 'groupes',
    fromPrice: 'à partir de {{price}}',
    unitsInBuilding: '{{count}} logements dans cet immeuble',
    groupUnits: 'unités',
    sameBuilding: 'Même bâtiment',
    sameArea: 'Zone la plus proche',
    sameCategory: 'Même catégorie',
    anyGroup: 'Unités',
    priceFrom: 'à partir de',
    bookAll: 'Réserver les {{count}}',
    playTour: 'Lire la visite',
    approxMapNote: 'Les localisations sont approximatives. Connectez-vous pour voir l\'emplacement exact.',
    pauseTour: 'Mettre la visite en pause',
    bookAllTitle: 'Réserver le groupe',
    bookAllDesc: 'Réservez les {{count}} unités comme un ensemble unique.',
    bookAllSummary: '{{count}} unités · {{nights}} nuits',
    bookAllSomeFailed: 'Certaines unités n\'ont pas pu être réservées.',
    bookAllDone: 'Groupe réservé ({{ok}}/{{count}}).',
    structRoomIn: 'Chambre à {{building}}',
    structRoomsSameApartment: '{{count}} chambres dans le même appartement',
    structRoomsSameBuilding: '{{count}} chambres dans le même immeuble',
    structApartmentsSameBuilding: '{{count}} appartements dans le même immeuble',
    structStaysSameArea: '{{count}} logements dans le même quartier',
    structStaysSameCategory: '{{count}} logements · {{category}}',
    structUnits: '{{count}} unités',
    specFull: '{{guests}} voyageurs · {{bedrooms}} chambres · {{baths}} salles de bain',
    specShort: '{{bedrooms}} ch. · {{baths}} sdb',
  },
  detail: {
    guests: 'voyageurs',
    bedrooms: 'chambres',
    bathrooms: 'salles de bain',
    amenities: 'Équipements',
    location: 'Emplacement',
    nights: 'nuits',
    cleaningFee: 'Ménage',
    total: 'Total',
    iva: 'TVA ({{pct}}%)',
    ivaNote: 'Prix hors TVA : la TVA de 21% est ajoutée au total de la réservation. Facture d\'entreprise conforme.',
    bookNow: 'Réserver maintenant',
    loginToBook: 'Connectez-vous pour réserver',
    signInForDetails: 'Connectez-vous pour voir tous les détails.',
    approxLocation: 'Localisation approximative (rayon ~700 m)',
    checkin: 'Arrivée',
    checkout: 'Départ',
    tooManyGuests: 'Ce logement accueille jusqu\'à {{capacity}} voyageurs.',
    minStayWarning: 'Séjour minimum : {{count}} nuit | Séjour minimum : {{count}} nuits',
    nightsWithCount: '{{count}} nuit | {{count}} nuits',
  },
  booking: {
    title: 'Réserver maintenant',
    subtitle: 'Vérifiez les données du voyageur. Le montant est recalculé sur le serveur.',
    confirm: 'Confirmer la réservation',
    guestName: 'Nom du voyageur',
    guestNamePlaceholder: 'Nom et prénom',
    guestNif: 'NIF du voyageur',
    datesRequired: 'Sélectionnez des dates valides',
    nameRequired: 'Saisissez le nom du voyageur',
    nifInvalid: 'NIF non valide',
    requestCreated: 'Réservation créée. En attente de paiement.',
    notAvailable: 'Ces dates ne sont plus disponibles.',
    notApproved: 'Votre compte n\'est pas autorisé à réserver.',
    createError: 'La réservation n\'a pas pu être créée. Veuillez réessayer.',
    awaitingDesc: 'Réservation créée. Effectuez le paiement pour la confirmer.',
    totalWithIva: 'Total (TVA incluse)',
    priceEstimateNote: 'Prix estimé : le montant final est calculé par bitutravel lors de la réservation.',
    total: 'Total',
    reference: 'Référence',
    openPaymentLink: 'Ouvrir le lien de paiement',
    mockDevNote:
      'Mode développement : le paiement est simulé. Cliquez pour marquer comme payé et simuler le webhook Revolut.',
    markPaidDev: 'Marquer comme payé (dev)',
    markPaidError: 'Le paiement n\'a pas pu être simulé.',
    paid: 'Paiement confirmé',
    paidDesc: 'Votre réservation est confirmée. Vous recevrez la facture par e-mail.',
    viewBookings: 'Voir mes réservations',
    paymentStatus: 'Paiement',
    bookingsTitle: 'Mes réservations',
    browseStays: 'Rechercher un logement',
    summaryTotal: 'Réservations',
    summaryUpcoming: 'À venir',
    summaryInstay: 'En séjour',
    summarySpend: 'Dépense totale',
    summaryPendingNote: 'Vous avez {{count}} réservations en attente de paiement.',
    payStatusPaid: 'Payé',
    payStatusPending: 'En attente',
    payStatusAwaiting: 'En attente de paiement',
    payStatusRefunded: 'Remboursé',
    payStatusFailed: 'Échec',
    payStatusScheduled: 'Programmé',
    empty: 'Vous n\'avez pas encore de réservations.',
    statusAwaitingPayment: 'En attente de paiement',
    statusConfirmed: 'Confirmée',
    statusActive: 'En cours',
    statusCompleted: 'Terminée',
    statusCancelled: 'Annulée',
    statusDisputed: 'En litige',
    notFound: 'Réservation introuvable.',
    viewProperty: 'Voir le logement',
    cleaningFee: 'Ménage',
    platformFee: 'Commission bitutravel',
    cancelBooking: 'Annuler la réservation',
    cancelConfirm:
      'Voulez-vous vraiment annuler cette réservation ? Cette action est irréversible.',
    cancelConfirmYes: 'Oui, annuler',
    cancelledToast: 'Réservation annulée.',
    cancelError: 'La réservation n\'a pas pu être annulée.',
    cancelReason: 'Motif d\'annulation',
    copyLink: 'Copier le lien',
    tabFuture: 'À venir',
    tabPresent: 'En cours',
    tabPast: 'Passées',
    emptyTab: 'Aucune réservation dans cette section.',
    purpose: 'Motif du voyage',
    purposeLeisure: 'Personnel',
    purposeConference: 'Congrès / événement',
    purposeProject: 'Projet',
    purposeRelocation: 'Relocalisation',
    purposeOther: 'Autre',
    eventName: 'Nom de l\'événement',
    eventNamePlaceholder: 'ex. Mobile World Congress 2026',
    teamSize: 'Voyageurs',
    teamNotes: 'Détails de l\'équipe',
    teamNotesPlaceholder: 'Noms des voyageurs, chambre, notes…',
    teamDetails: 'Détails du voyage / équipe',
    employee: 'Employé',
    employeePlaceholder: 'Non assigné',
    employeeNone: 'Aucun employé',
    employeeFilterAll: 'Tous les employés',
    employeeCardTitle: 'Employé assigné',
  },
  team: {
    title: 'Équipe',
    addEmployee: 'Ajouter un employé',
    intro: 'Gérez les employés de votre entreprise. Affectez-les à des réservations pour qu\'ils reçoivent les détails par email, ou activez-les pour qu\'ils fassent leurs propres réservations facturées à l\'entreprise.',
    featureRosterTitle: 'Annuaire',
    featureRosterDesc: 'Nom, email, téléphone et NIF de chaque employé. La plupart sont récurrents : réutilisables à chaque réservation.',
    featureEmailTitle: 'Détails par email',
    featureEmailDesc: 'En réservant, affectez l\'employé qui reçoit les données du séjour par email.',
    featureActivateTitle: 'Activer pour réserver',
    featureActivateDesc: 'Activez un employé pour qu\'il se connecte avec son email et réserve au nom de l\'entreprise.',
    empty: 'Aucun employé pour l\'instant. Bientôt vous pourrez les ajouter et les affecter à vos réservations.',
    editEmployee: 'Modifier l\'employé',
    editDesc: 'Mettre à jour les coordonnées de l\'employé.',
    addDesc: 'Ajoutez un employé et activez-le pour qu\'il se connecte avec son propre e-mail.',
    addNote: 'L\'employé est ajouté au registre. Pour qu\'il se connecte avec son propre e-mail, activez son accès ensuite.',
    activateLogin: 'Activer l\'accès',
    alreadyActivated: 'Cet employé a déjà un accès activé.',
    platformUnavailable: 'Le service est indisponible pour le moment. Réessayez plus tard.',
    phone: 'Téléphone',
    updated: 'Employé mis à jour.',
    added: 'Employé ajouté.',
    emailExists: 'Un employé avec cet e-mail existe déjà.',
    activated: 'Employé activé.',
    deactivated: 'Employé désactivé.',
    deleted: 'Employé supprimé.',
    activate: 'Activer',
    deactivate: 'Désactiver',
    delete: 'Supprimer',
    deleteTitle: 'Supprimer l\'employé',
    deleteConfirm: 'Voulez-vous vraiment supprimer {{name}} ? Son compte sera supprimé et cela est irréversible.',
    statusActive: 'Actif',
    statusInactive: 'Inactif',
    statusRoster: 'Liste seule',
    tempPwTitle: 'Mot de passe temporaire',
    tempPwDesc: 'Ceci est le mot de passe temporaire de {{name}}. Partagez-le en toute sécurité.',
    tempPwWarn: 'Il ne sera plus affiché. Copiez-le maintenant.',
    copy: 'Copier',
    copied: 'Copié',
  },
  agency: {
    title: 'Clients',
    intro: 'Gérez les entreprises clientes de votre agence. Ajoutez-les avec leur e-mail de facturation et réservez des voyages en leur nom — la facture va à l\'entreprise cliente.',
    addClient: 'Ajouter une entreprise cliente',
    clientEmail: 'E-mail de facturation de l\'entreprise',
    clientEmailPlaceholder: 'factures@entreprise.fr',
    addNote: 'L\'entreprise doit avoir un compte bitutravel et être approuvée. Vérifié lors de l\'association.',
    empty: 'Vous n\'avez pas encore d\'entreprises clientes. Ajoutez-en une pour réserver en son nom.',
    client: 'Client',
    unknownClient: 'Entreprise cliente',
    unlinkConfirm: 'Voulez-vous vraiment dissocier {{name}} ? Vous ne pourrez plus réserver en son nom.',
    unlinkedBtn: 'Dissocier',
    unlinked: 'Entreprise cliente dissociée.',
    linked: 'Entreprise cliente associée : {{name}}.',
    notFound: 'Aucune entreprise approuvée trouvée avec cet e-mail.',
    billTo: 'Réserver pour',
    selectClient: 'Sélectionnez une entreprise cliente',
    noClientsWarn: 'Ajoutez d\'abord une entreprise cliente dans Clients pour pouvoir réserver.',
  },

  invoices: {
    title: 'Factures et notes de frais',
    backToBookings: '← Mes réservations',
    count: 'Factures',
    baseTotal: 'Base HT',
    ivaTotal: 'TVA',
    irpfTotal: 'IRPF retenu',
    total: 'Total facturé',
    invoicesTitle: 'Factures',
    ref: 'Réservation',
    parteTitle: 'Notes de frais du voyageur',
    parteEmpty: 'Aucune note de frais pour le moment.',
    empty:
      'Vous n\'avez pas encore de factures. Elles sont générées automatiquement à la confirmation d\'une réservation.',
    regenTitle: 'Réémettre les documents',
    regenDesc:
      'Régénère la facture et la note de frais du voyageur d\'une réservation (utile pour la comptabilité).',
    regenDone: 'Documents régénérés.',
    regenError: 'Les documents n\'ont pas pu être régénérés.',
    downloadError: 'Le document n\'a pas pu être téléchargé.',
    navInvoices: 'Factures',
    period30: '30 derniers jours',
    period90: '90 derniers jours',
    period365: '12 derniers mois',
    periodAll: 'Tout l\'historique',
    periodEmpty: 'Aucune facture sur cette période.',
    exportCsv: 'Exporter en CSV',
    exportZip: 'Télécharger les PDF (ZIP)',
    statusIssued: 'Émise',
    statusPaid: 'Payée',
    statusVoid: 'Annulée',
  },
  owner: {
    calendar: {
      title: 'Calendrier des tarifs',
      subtitle: 'Prix, séjour minimum et disponibilité nuit par nuit',
      navButton: 'Tarifs',
      backendRequired: 'Configure le backend Supabase pour utiliser le calendrier des tarifs.',
      basePrice: 'Tarif de base',
      cleaningFee: 'Ménage',
      applyTitle: 'Appliquer à la sélection',
      clearSelection: 'Effacer la sélection',
      selectHint: 'Cliquez sur une nuit puis sur une autre pour choisir une plage. Chaque case est une nuit — la dernière marquée est la nuit précédant le départ.',
      selectedNights: '{{count}} nuit sélectionnée | {{count}} nuits sélectionnées',
      skipped: '{{count}} nuit ignorée (réservée ou passée) | {{count}} nuits ignorées (réservées ou passées)',
      noneEditable: 'Toutes les nuits sélectionnées sont réservées ou déjà passées.',
      priceLabel: 'Nouveau prix (€)',
      pricePlaceholder: '€ / nuit',
      minNightsLabel: 'Séjour minimum (nuits)',
      minNightsPlaceholder: 'p. ex. 5',
      applyPrice: 'Fixer le prix',
      applyMinNights: 'Fixer le minimum',
      block: 'Bloquer',
      unblock: 'Ouvrir',
      removeOverride: 'Retirer la personnalisation',
      blockNameLabel: 'Nom du bloc',
      blockNamePlaceholder: 'p. ex. Entretien, Travaux…',
      saved: 'Calendrier mis à jour',
      saveError: 'Impossible d’enregistrer le calendrier.',
      legend: {
        available: 'Disponible',
        priced: 'Prix personnalisé',
        blocked: 'Bloquée',
        booked: 'Réservée',
        past: 'Passée',
        sunday: 'Dimanche',
      },
      ical: {
        title: 'Exporter le calendrier (iCal)',
        desc: 'Reliez ce flux à Airbnb, Booking.com ou votre channel manager pour synchroniser les réservations.',
        copy: 'Copier',
        copied: 'Lien copié',
        unavailable: 'Flux non disponible pour ce logement.',
      },
      bulk: {
        from: 'Du',
        to: 'au',
        allDays: 'Tous les jours',
        weekdays: 'En semaine',
        weekends: 'Week-end',
        allYear: 'Toute l’année',
        pickDay: 'Choisissez au moins un jour de la semaine',
      },
    },
    revenueTitle: 'Revenus',
    invoicesTitle: 'Factures et encaissements',
    invoicesNote: 'Les factures sont générées automatiquement à la confirmation d’une réservation ; les paiements sont réglés selon le calendrier bitutravel.',
    gross: 'Base (hors TVA)',
    fee: 'Commission bitutravel',
    iva: 'TVA',
    net: 'Revenu net',
    paidOut: 'Versé',
    pending: 'Versement en attente',
    monthlyTitle: 'Revenus par mois',
    perPropertyTitle: 'Par logement',
    property: 'Logement',
    bookings: 'Réservations',
    nights: 'Nuits',
    payoutsTitle: 'Versements aux propriétaires',
    eligibleDesc: 'Réservations confirmées prêtes à être versées :',
    payNow: 'Payer',
    scheduled: 'Programmé',
    noPayouts: 'Aucun versement pour le moment.',
    noData: 'Aucune donnée pour le moment.',
    payoutDone: 'Versement effectué.',
    payoutError: 'Le versement n\'a pas pu être effectué.',
    range7: '7 j',
    range15: '15 j',
    range30: '30 j',
    range90: '90 j',
    range12m: '12 m',
    rangeAll: 'Tout',
    payoutConfirmTitle: 'Confirmer le versement',
    payoutConfirmDesc: 'Effectuer le versement de la réservation #{{id}} pour {{amount}} ?',
    confirm: 'Confirmer',
    propertiesNav: 'Calendrier',
    propertiesTitle: 'Calendrier',
    newProperty: 'Ajouter un logement',
    editProperty: 'Modifier',
    propertyUntitled: 'Logement sans titre',
    propertiesEmpty: 'Vous n\'avez pas encore publié de logement.',
    pendingReviewNote:
      'Les nouveaux logements restent en examen jusqu\'à leur validation par l\'équipe bitutravel. Vous serez averti par e-mail.',
    pendingEditorNote:
      'Ce logement est en cours d\'examen. Vous pouvez continuer à le modifier ; il apparaîtra dans la recherche une fois approuvé.',
    unpublished: 'Non publié',
    photoCount: '{{count}} photos',
    noPhotos: 'Aucune photo',
    unitCount: '{{count}} unités',
    viewCalendar: 'Calendrier',
    viewList: 'Liste',
    searchUnits: 'Rechercher des unités…',
    sortName: 'Nom',
    sortRecent: 'Récentes',
    chipNeedsPhotos: 'Sans photos',
    stripNoBookings: 'Aucune réservation dans les 30 prochains jours',
    pms: {
      title: 'Gestionnaire de réservations',
      subtitle: 'Réservations par unité — glissez pour déplacer',
      prev: 'Précédent',
      next: 'Suivant',
      today: "Aujourd'hui",
      view_month: 'Mois',
      view_week: 'Semaine',
      dragHint: 'Glissez une réservation vers une autre unité ou date pour la déplacer.',
      moved: 'Réservation déplacée',
      moveError: 'Impossible de déplacer la réservation',
      noCity: 'Aucune ville',
      cities: 'Villes',
      properties: 'Propriétés',
      unit: 'Unité',
      overall: 'Vue d\'ensemble',
      allProperties: 'Toutes les propriétés',
      noUnits: "Aucune unité pour l'instant. Ajoutez une propriété pour commencer.",
      guest: 'Client',
      dragHintBlocked: "Click an empty day to block / open it. Drag a booking to move it; drag its right edge to extend or shorten.",
      addBooking: "Add booking",
      dates: 'Dates',
      autoRate: 'Tarif automatique',
      applyCustomPrice: 'Appliquer un prix personnalisé (remise)',
      customPriceHint: 'Modifiez le total pour appliquer une remise. Il est réparti entre les nuits.',
      manualBooking: "Manual booking",
      manualBadge: "Manual",
      guestName: "Guest name",
      guestNif: "Guest NIF",
      guests: "Guests",
      pricePerNight: "Prix par nuit",
      checkin: "Check-in",
      checkout: "Check-out",
      block: "Block",
      unblock: "Open",
      blocked: "Blocked",
      blockTitle: 'Bloquer la nuit',
      blockNameLabel: 'Nom (facultatif)',
      blockNamePlaceholder: 'p. ex. Entretien',
      blockNameHint: 'Affiché sur le jour bloqué.',
      blockConfirm: 'Bloquer',
      manualCreated: "Manual booking created",
      manualError: "Could not create manual booking",
      notAvailable: "Not available for those dates",
      belowMinStay: "Below the minimum stay for this unit",
      detail: "Booking detail",
      property: "Property",
      nights: "Nights",
      total: "Total",
      iva: "VAT",
      fee: "Platform fee",
      payout: "Payout",
      channel: "Channel",
      status: "Status",
      statusConfirmed: "Confirmed",
      statusActive: "In stay",
      statusPending: "Pending",
      statusAwaiting: "Awaiting payment",
      statusCancelled: "Cancelled",
      channelManual: "Manual",
      channelDirect: "Direct",
      channelIcal: "iCal (importé)",
      icalNoPayout: "Blocage externe — sans paiement",
      confirmMove: "Confirm move",
      moveFrom: "From",
      moveTo: "To",
      moveNote: "Availability and price are revalidated on confirm.",
      confirm: "Confirm",
      extendTitle: "Extend stay",
      shortenTitle: "Shorten stay",
      newCheckout: "New check-out",
      extended: "Stay updated",
      extendError: "Could not update the stay",
    },
    products: {
      nav: 'Logements',
      title: 'Logements',
      subtitle: 'Tarifs et canaux par unité. Le tarif par défaut se synchronise avec le prix du bien.',
      empty: 'Vous n’avez pas encore de biens.',
      ratePlans: 'Tarifs',
      addRatePlan: 'Ajouter un tarif',
      editRatePlan: 'Modifier le tarif',
      ratePlanDesc: 'Un tarif est une offre vendable de cette unité (prix, ménage, séjour minimum).',
      noPlans: 'Aucun tarif pour l’instant.',
      planCount: '{{count}} tarifs',
      icalCount: '{{count}} iCal',
      default: 'Par défaut',
      inactive: 'Inactif',
      minNights: 'min. {{count}} nuits',
      minNightsLabel: 'Nuits minimum',
      feePct: 'commission {{pct}}%',
      feePctLabel: 'Commission bitutravel (%)',
      feePctPlaceholder: 'défaut',
      feePctHint: 'Vide = commission globale. 0 = client apporté (sans commission).',
      makeDefault: 'Tarif par défaut',
      name: 'Nom',
      basePrice: 'Prix de base (NET)',
      cleaningFee: 'Ménage',
      cancellation: 'Annulation',
      policy: {
        flexible: 'Flexible',
        moderate: 'Modéré',
        strict: 'Strict',
      },
      save: 'Enregistrer',
      cancel: 'Annuler',
      edit: 'Modifier',
      delete: 'Supprimer',
      confirmDelete: 'Supprimer ?',
      defaultNoDelete: 'Le tarif par défaut ne peut pas être supprimé.',
      created: 'Tarif créé.',
      updated: 'Tarif mis à jour.',
      deleted: 'Tarif supprimé.',
      channels: 'Canaux',
      addChannel: 'Ajouter un canal',
      direct: 'Direct',
      noConnections: 'Aucune connexion. Ajoutez un canal iCal pour importer un calendrier externe.',
      icalChannel: 'iCal',
      addIcal: 'Ajouter une connexion iCal',
      icalDesc: 'Collez l’URL iCal d’un calendrier externe (Airbnb, Booking, Google…). Les dates réservées bloqueront cette unité.',
      icalUrl: 'URL du calendrier iCal',
      addAndSync: 'Ajouter et synchroniser',
      syncNow: 'Synchroniser',
      syncAll: 'Tout synchroniser',
      syncDone: '{{upserted}} importées, {{cancelled}} annulées, {{conflicts}} conflits',
      syncAllDone: 'Synchronisation terminée : {{upserted}} importées, {{cancelled}} annulées, {{conflicts}} conflits',
      syncError: 'Erreur de synchronisation',
      lastSync: 'Dernière synchronisation',
      neverSynced: 'Pas encore synchronisé',
      connectionDeleted: 'Connexion supprimée.',
      connStatus: {
        pending: 'En attente',
        active: 'Actif',
        paused: 'En pause',
        error: 'Erreur',
      },
      rangeActionTitle: 'Plage sélectionnée',
      rangeActionHint: 'Que veux-tu faire avec ces nuits ?',
      selectHint: 'Clique sur une nuit puis sur une autre (ou deux fois sur la même) pour choisir une plage.',
    },

    status: {
      pending: 'En examen',
      approved: 'Publié',
      rejected: 'Refusé',
    },
    step1: 'Informations',
    step2: 'Description',
    step3: 'Emplacement et photos',
    backStep: 'Retour',
    nextStep: 'Suivant',
    saveProperty: 'Enregistrer le logement',
    fieldType: 'Type d\'hébergement',
    type: {
      apartment: 'Appartement',
      studio: 'Studio',
      house: 'Maison',
      room: 'Chambre',
      loft: 'Loft',
      duplex: 'Duplex',
      cabin: 'Cabane',
      guesthouse: 'Maison d’hôtes',
      hotel: 'Hôtel',
      bed_breakfast: 'Chambre d’hôtes',
    },
    fieldCapacity: 'Capacité (voyageurs)',
    fieldBeds: 'Lits',
    fieldPrice: 'Prix par nuit (€)',
    fieldCleaning: 'Frais de ménage (€)',
    fieldCheckinTime: "Heure d'arrivée",
    fieldCheckoutTime: 'Heure de départ',
    fieldTitleEs: 'Titre (espagnol)',
    fieldTitleEn: 'Titre (anglais)',
    fieldDescEs: 'Description (espagnol)',
    fieldDescEn: 'Description (anglais)',
    fieldCity: 'Ville',
    fieldCategory: 'Catégorie',
    fieldCategoryHint: 'executive, standard, suite…',
    fieldBuilding: 'Bâtiment / adresse',
    fieldUnitLabel: 'Libellé de l\'unité',
    fieldNeighborhood: 'Quartier / district',
    fieldNeighborhoodHint: 'ex. Chamberí',
    fieldPostalCode: 'Code postal',
    cityPrefillNote:
      'En choisissant une ville, nous renseignons les coordonnées avec son centre ; ajustez-les si vous connaissez l\'emplacement exact.',
    photosAfterCreate: 'Enregistrez d\'abord le logement pour pouvoir ajouter des photos.',
    addPhotos: 'Ajouter des photos',
    deletePhoto: 'Supprimer la photo',
    photoUploadError: 'La photo n\'a pas pu être téléversée.',
    photoDeleteError: 'La photo n\'a pas pu être supprimée.',
    createdToast: 'Logement créé. Il est en cours d\'examen.',
    savedToast: 'Logement enregistré.',
    saveError: 'Le logement n\'a pas pu être enregistré.',
    fiscal: {
      title: 'Données fiscales & VeriFactu',
      subtitle: 'Informations émetteur et autorisation pour que bitutravel transmette vos factures à l’AEAT.',
      statusActive: 'VeriFactu actif. Vos factures d’hébergement sont transmises à l’AEAT.',
      statusPending: 'VeriFactu en attente. Vos factures sont émises mais non transmises à l’AEAT.',
      statusRevoked: 'Votre autorisation a été révoquée. La transmission à l’AEAT est suspendue.',
      active: 'Actif',
      pending: 'En attente',
      revoked: 'Révoqué',
      issuerTitle: 'Données émetteur',
      personaType: 'Type de personne',
      personaF: 'Physique',
      personaJ: 'Morale',
      seriesLodging: 'Série de factures',
      seriesHint: 'Série AEAT pour vos factures d’hébergement (défaut O). Ne pas changer sans motif.',
      legalName: 'Raison sociale / Nom',
      nif: 'NIF',
      country: 'Pays',
      street: 'Adresse',
      postalCode: 'Code postal',
      city: 'Ville',
      save: 'Enregistrer les données fiscales',
      saved: 'Données fiscales enregistrées.',
      saveError: 'Impossible d’enregistrer les données fiscales.',
      errFields: 'Raison sociale et NIF sont obligatoires.',
      apoderamientoTitle: 'Mandat de représentation',
      apoderamientoDesc: 'Pour transmettre des factures à l’AEAT en votre nom, bitutravel a besoin d’un mandat signé. Téléversez le mandat signé pour activer la transmission.',
      poderOnFile: 'Mandat enregistré :',
      uploadPoder: 'Téléverser le mandat signé (PDF)',
      poderHint: 'PDF, 10 Mo max.',
      granted: 'Mandat activé. VeriFactu transmettra vos prochaines factures.',
      grantError: 'Impossible d’enregistrer le mandat.',
      errPoderSize: 'Le fichier dépasse 10 Mo.',
      legalNote: 'En téléversant le mandat, vous confirmez avoir signé l’autorisation de représentation permettant à bitutravel de transmettre des factures à l’AEAT (RD 1007/2023).',
      bannerPending: 'Activez VeriFactu pour transmettre vos factures à l’AEAT.',
      bannerRevoked: 'Votre autorisation VeriFactu est révoquée.',
      bannerCta: 'Configurer',
    },

  },
  profile: {
    title: 'Profil et paramètres',
    navProfile: 'Profil',
    accountSection: 'Compte',
    statusLabel: 'Statut du compte',
    rejectionReason: 'Motif du refus',
    detailsSection: 'Données fiscales',
    languageSection: 'Langue',
    localeLabel: 'Langue préférée',
    localeHint: 'Enregistrée dans votre compte et appliquée sur tous vos appareils.',
    localeSaved: 'Langue mise à jour.',
    billingSection: 'Facturation et paiement',
    invoiceEmail: 'E-mail de facturation',
    invoiceEmailPlaceholder: 'factures@entreprise.fr',
    ibanTransfer: 'IBAN (paiement par virement)',
    ibanHint: 'Si vous préférez payer par virement bancaire.',
    preferredMethod: 'Moyen de paiement préféré',
    methodCard: 'Carte',
    methodTransfer: 'Virement',
    savedCards: 'Cartes enregistrées',
    defaultCard: 'Par défaut',
    billingProcessorNote: 'Les données de carte sont tokenisées avec Revolut ; nous ne stockons jamais le numéro complet.',
    billingSaved: 'Facturation mise à jour.',
  },
  auth: {
    registerTitle: 'Créer un compte',
    loginTitle: 'Connexion',
    rolePrompt: 'Comment utiliserez-vous bitutravel ?',
    roleBook: 'Je réserve des séjours',
    roleList: 'Je publie des logements',
    roleCompany: 'Entreprise',
    roleAutonomo: 'Indépendant',
    roleOwner: 'Propriétaire',
    roleEmployeeLabel: 'Employé',
    roleAgencyLabel: 'Agence',
    roleCompanyDesc: 'Réservations centralisées pour votre entreprise',
    roleAutonomoDesc: 'Pour les professionnels indépendants',
    roleOwnerDesc: 'Publiez et monétisez vos logements',
    roleBookerPrompt: 'Qui réserve ?',
    pathManager: 'Je gère des logements',
    pathManagerDesc: 'Publiez votre inventaire et gérez tarifs et disponibilités',
    pathBook: 'Je réserve des séjours',
    pathBookDesc: 'Pour les entreprises, salariés et indépendants',
    roleEmployee: 'Je travaille dans une entreprise',
    roleEmployeeDesc: 'Je réserve avec la carte de mon entreprise ; la facture lui est adressée',
    contactName: 'Personne de contact',
    email: 'E-mail',
    fullName: 'Nom complet',
    legalName: 'Raison sociale',
    cif: 'CIF',
    nif: 'NIF / DNI',
    address: 'Adresse',
    iban: 'IBAN pour les versements',
    irpf: 'Retenue IRPF (%)',
    submit: 'Envoyer la demande',
    pendingTitle: 'Demande en cours d\'examen',
    pendingDesc: 'Notre équipe vérifie votre compte. Vous recevrez un e-mail une fois celui-ci approuvé.',
    pendingApproved: 'Votre compte a été approuvé !',
    checkStatus: 'Vérifier à nouveau',
    profileErrorTitle: 'Impossible de charger votre profil',
    profileErrorDesc:
      'Votre session est valide mais nous n\'avons pas trouvé les données de votre compte. Réessayez ou déconnectez-vous.',
    rejectedTitle: 'Demande refusée',
    rejectedDesc: 'Votre demande n\'a pas été approuvée. Motif : {{reason}}',
    loginPrompt: 'Vous avez déjà un compte ? Connectez-vous',
    registerPrompt: 'Pas encore de compte ? Inscrivez-vous',
    login: 'Connexion',
    magicLink: 'Envoyer un lien magique',
    magicLinkSent:
      'Nous avons envoyé un lien de connexion magique à votre adresse e-mail. Ouvrez-le pour vous connecter.',
    cifInvalid: 'CIF non valide',
    cifInRegistry: 'Trouvée dans l\'annuaire',
    nifOrCifInvalid: 'NIF/CIF non valide',
    ibanInvalid: 'IBAN non valide',
    irpfRange: 'Doit être compris entre 7 et 45 %',
    loginErrorGeneric: 'La connexion a échoué. Vérifiez l\'e-mail.',
    loginRateLimited: 'Trop de tentatives. Veuillez attendre une minute.',
    loginEmailNotConfirmed: 'Confirmez votre e-mail avant de vous connecter.',
  },
  admin: {
    approvalsTitle: 'File d\'approbation',
    approve: 'Approuver',
    reject: 'Refuser',
    reason: 'Motif',
    empty: 'Aucune demande en attente',
    typeCompany: 'Entreprise',
    typeAutonomo: 'Indépendant',
    typeOwner: 'Propriétaire',
    approvedToast: 'Demande approuvée',
    rejectedToast: 'Demande refusée',
    decisionFailed: 'Impossible d\'enregistrer la décision',
    searchPlaceholder: 'Rechercher par nom, e-mail ou NIF/CIF',
    tabAll: 'Toutes',
    tabCompany: 'Entreprises',
    tabAutonomo: 'Indépendants',
    tabOwner: 'Propriétaires',
    confirmApprove: 'Approuver {{name}} ?',
    confirmReject: 'Refuser {{name}} ?',
    confirm: 'Confirmer',
    reasonRequired: 'Indiquez le motif du refus',
    noMatches: 'Aucun résultat',
    roleAdmin: 'Administration',
    consoleTitle: "Console d'administration",
    navApprovals: 'Approbations',
    navAccounts: 'Comptes',
    navBookings: 'Réservations',
    navInvoices: 'Factures',
    tabAgency: 'Agences',
    tabEmployee: 'Employés',
    tabBlocked: 'Bloqués',
    typeAgency: 'Agence',
    typeEmployee: 'Employé',
    typeAdmin: 'Admin',
    typeSuperadmin: 'Superadmin',
    statusPending: 'En attente',
    active: 'Actif',
    blocked: 'Bloqué',
    rejected: 'Rejeté',
    block: 'Bloquer',
    unblock: 'Débloquer',
    blockedToast: 'Compte bloqué',
    unblockedToast: 'Compte débloqué',
    manageFailed: "Impossible de modifier l'état du compte",
    commissionDefault: 'Par défaut {{pct}}%',
    commissionEdit: 'Modifier',
    commissionSave: 'Enregistrer',
    commissionCancel: 'Annuler',
    commissionSaved: 'Commission mise à jour.',
    commissionFailed: 'Impossible de mettre à jour la commission.',
    lastActions: "{{count}} actions d'administration enregistrées",
    noBookings: 'Aucune réservation.',
    noInvoices: 'Aucune facture.',
    kindCommission: 'Commission',
    kindLodging: 'Hébergement',
    vfFiled: 'VeriFactu transmise',
    vfIncidence: 'Incidence',
    vfPending: 'VeriFactu en attente',
    navRegistry: 'Annuaire',
    vfSubmit: 'Envoyer à l\'AEAT',
    vfSubmitted: 'Envoyée à l\'AEAT',
    vfSubmitFailed: 'Échec de l\'envoi à l\'AEAT',
    vfNotConfigured: 'Certificat VeriFactu non configuré',
    void: 'Annuler',
    voidConfirm: 'Annuler cette facture ? Si elle a été transmise à l\'AEAT, une annulation sera envoyée.',
    voidDone: 'Facture annulée',
    voidFailed: 'Impossible d\'annuler la facture',
    voidAnulacionPending: 'Annulation AEAT en attente de certificat',
    voided: 'Annulée',
    rect: 'Rectificative',
    rectConfirm: 'Émettre une rectificative remplaçant cette facture ?',
    rectDone: 'Rectificative émise',
    rectFailed: 'Impossible d\'émettre la rectificative',
    registry: {
      addTitle: 'Ajouter une entreprise',
      editTitle: 'Modifier l\'entreprise',
      listTitle: 'Annuaire des entreprises',
      cif: 'CIF',
      legalName: 'Raison sociale',
      street: 'Rue',
      postalCode: 'Code postal',
      city: 'Ville',
      province: 'Province',
      country: 'Pays',
      save: 'Enregistrer',
      saved: 'Entreprise enregistrée',
      saveError: 'Impossible d\'enregistrer l\'entreprise',
      deleted: 'Entreprise supprimée',
      deleteError: 'Impossible de supprimer l\'entreprise',
      errFields: 'Le CIF et la raison sociale sont obligatoires',
      empty: 'Aucune entreprise dans l\'annuaire pour l\'instant',
      edit: 'Modifier',
    },
  },
  dashboard: {
    roleLabel: 'Rôle',
    emailLabel: 'E-mail',
  },
  notFound: {
    title: 'Page introuvable',
    desc: 'La page que vous recherchez n\'existe pas ou a changé d\'adresse.',
  },
  error: {
    boundaryDesc: 'Une erreur est survenue. Rechargez la page pour continuer.',
    boundaryReload: 'Recharger',
  },
  common: {
    loading: 'Chargement…',
    error: 'Une erreur est survenue',
    favorite: 'Enregistrer dans les favoris',
    required: 'Obligatoire',
    back: 'Retour',
    retry: 'Réessayer',
    continue: 'Continuer',
    done: 'Terminé',
    save: 'Enregistrer',
    plusIva: '+ TVA',
    cancel: 'Annuler',
    rooms: 'chambres',
    room: 'chambre',
    bathrooms: 'salles de bain',
    bathroom: 'salle de bain',
    increment: 'Augmenter',
    decrement: 'Diminuer',
    edit: 'Modifier',
    close: "Fermer",
    previous: 'Précédent',
    next: 'Suivant',
  },
  amenities: {
    wifi: 'Wi-Fi',
    parking: 'Parking',
    ac: 'Climatisation',
    heating: 'Chauffage',
    washing: 'Machine à laver',
    dishwasher: 'Lave-vaisselle',
    elevator: 'Ascenseur',
    furnished: 'Meublé',
    kitchen: 'Cuisine',
    meeting_room: 'Salle de réunion',
    printer: 'Imprimante',
    gym: 'Salle de sport',
  },
} as const